import {MdLogin} from "react-icons/md";
import axios from "axios";
import { useState } from "react";
import { BACKEND_URL } from "./URL";

function LoginBox({flap,setFlap,setLoginUser,setBatchType,setBatchTypeDict,setIsBatch,setIsSingle,setShowAlert, setAlertMessage}){
    const [username,setUsername]= useState('');
    const [password,setPassword]= useState('');
    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
    };
    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };
    const handleClick = async ()=>{
        
        const payload={
            username:username,
            password:password
        };
        try {
            const response = await axios.post(`${BACKEND_URL}/check`, payload);
            if (response.data.status === 'done'){
                setLoginUser(response.data);
                setFlap(!flap); 
                setIsSingle(response.data.isSingle);
                setIsBatch(response.data.isBatch);
                setBatchTypeDict(response.data.batch_type);
                setBatchType(Object.keys(response.data.batch_type)[0]);
                setAlertMessage("Logged in successfully");
                setShowAlert(true);
            }
            else{
                setAlertMessage("Wrong credentials");
                setShowAlert(true);
            }
           
            

          } catch (error) {
            console.error('Error uploading file:', error);
          }

    }

    return (
    <div className="flap-container-login" style={{'width':'100%',backgroundColor:"whitesmoke",boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'}}>
        <div className="col-auto">
            <label  className="col-form-label">Username</label>
        </div>
        <div className="col-auto">
            <input onChange={handleUsernameChange} value={username} type="text" className="form-control shadow-none" aria-describedby="passwordHelpInline" placeholder="Username"></input>
        </div>
        <div className="col-auto">
            <label className="col-form-label" style={{marginLeft:'10px'}}>Password</label>
        </div>
        <div className="col-auto">
            <input onChange={handlePasswordChange} value={password} type="password" className="form-control shadow-none" aria-describedby="passwordHelpInline" placeholder="Password"></input>
        </div>
        <div className="col-auto">
            <button onClick={handleClick} className="karma_button" style={{marginLeft:'10px'}}><MdLogin style={{fontSize:'20px',marginRight:'5px'}}/>Login</button>
        </div>
    
    
   
</div>)
}

export default LoginBox;